import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React, { forwardRef } from 'react';
import { IconButtonContainer } from '../styles';
import { colors } from '@chegg-ui/theme';
var IconButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      screenReaderOnlyText = _ref.screenReaderOnlyText,
      disabled = _ref.disabled,
      dataTest = _ref['data-test'],
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'button' : _ref$type,
      buttonProps = _objectWithoutProperties(_ref, ["children", "size", "screenReaderOnlyText", "disabled", "data-test", "type"]);

  // we enforce specific icon sizes according to the overall button size
  var cloneProps = {
    size: size
  };

  if (disabled) {
    // when disabled, we also have to clone the color to overwrite anything set by the consumer
    cloneProps.svgColor = colors.greyLight;
  }

  return /*#__PURE__*/React.createElement(IconButtonContainer, _extends({}, buttonProps, {
    "data-test": dataTest ? dataTest : undefined,
    "aria-label": screenReaderOnlyText,
    ref: ref,
    disabled: disabled,
    size: size,
    type: type
  }), /*#__PURE__*/React.cloneElement(children, cloneProps));
});
IconButton.displayName = 'IconButton';
export default IconButton;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/button/dist/esm/variants/IconButton.js
// module id = 2197
// module chunks = 11